import AppTextField from "@/components/AppTextField";
import SendCodeButton from "@/components/SendCodeButton";
import AppLoadingButton from "@/components/mui/LoadingButton";
import API from "@/constant/API";
import { VerifyAction, VerifyOption } from "@/constant/VerifyConstant";
import { getTaskId, getUserInfo } from "@/redux/slices/user";
import { dispatch } from "@/redux/store";
import axiosInstance from "@/utils/axios";
import { Box, InputAdornment } from "@mui/material";
import { t } from "i18next";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import classes from "@/pages/security/css/index.module.less";
import {useTranslation} from "react-i18next";
import {enqueueSnackbar} from "notistack";
import SimpleHeader from "../components/Headers/SimpleHeader";

function SecurityEmailUpdate() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useSelector(state => state.user);
  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');

  const handleSubmit = async (evt) => {
    evt.preventDefault();

    const params = {
      email: email,
      code: code,
    };
    try {
      setLoading(true);
      const tokenModel = await axiosInstance.post(API.EMAIL_UPDATE_VERIFY, params);
      params['sign'] = tokenModel.sign;
      params['taskId'] = getTaskId();
      await axiosInstance.post(API.EMAIL_UPDATE, params);
      // TODO: toast 提示用户修改邮箱成功
      enqueueSnackbar(t('successful'), { variant: 'success' })
      dispatch(getUserInfo());
      navigate(-1);
    } finally {
      setLoading(false);
    }
  }

  if (!user) return null;

  return (<>
    <SimpleHeader />
    <Box className={classes["security-wrap"]}>
      <Box className={classes["security-title-wrap"]}>
        <div className={classes["security-title"]}>{t('email_update')}</div>
        <div className={classes["security-subtitle"]}>{t('email_subtitle')}</div>
      </Box>
      <form autoComplete="off" onSubmit={handleSubmit}>
        <Box className={classes["column-gap-wrap"]}>
          <AppTextField
            label={t('email')}
            placeholder={t('email')}
            onChange={(e) => setEmail(e.target.value.trim())}
            required
            value={email}
            fullWidth
            clearable
            onClear={() => setEmail('')}
          />
          <AppTextField
            label={t('code')}
            placeholder={t('code')}
            onChange={(e) => setCode(e.target.value.trim())}
            required
            value={code}
            fullWidth
            clearable
            onClear={() => setCode('')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SendCodeButton
                    btnText={t('send_code')}
                    action={VerifyAction.UPDATE_EMAIL}
                    enable={true}
                    params={{
                      email: email,
                    }}
                    onError={(error)=>{
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </form>
      <Box className={classes["fixed-button"]}>
        <AppLoadingButton
          fullWidth
          loading={loading}
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          onClick={handleSubmit}
        >
          {t('confirm')}
        </AppLoadingButton>
      </Box>
    </Box>
  </>);
}

export default SecurityEmailUpdate;
